var module={}; // this is solely to fix an error where box2d tries to assign to a property of module without checking existence.
// could also add polyfills in this file...